import moment from 'moment';
import ValetDataActionTypes from './valetData.types';

const INITITAL_STATE = {
  flightIdsLoading: false,
  customerDataLoading: false,
  dof: '',
  flightIds: [],
  filteredFlightIds: [],
  flightTimes: {},
  filter: {
    time: {
      start: moment().startOf('day'),
      end: moment().endOf('day'),
    },
  },
  flightCustomerData: null,
  selectedFlightIds: [],
  absentCustomers: [],
  customerCount: 0,
  error: null,
  destination: '',
};

//ES6 synntax leverage assignment if state is undefined, but if state == null then the INITIAL_STATE is not leveraged
const valetDataReducer = (state = INITITAL_STATE, action) => {
  switch (action.type) {
    case ValetDataActionTypes.GET_VALET_FLIGHT_IDS_SUCCESS:
      return {
        ...state,
        flightIds: action.payload,
        error: null,
      };

    case ValetDataActionTypes.GET_VALET_FLIGHT_TIMES_FAILURE:
    case ValetDataActionTypes.GET_VALET_FLIGHT_IDS_FAILURE:
    case ValetDataActionTypes.GET_VALET_CUSTOMER_DATA_FAILURE:
    case ValetDataActionTypes.FILTER_VALET_FLIGHTS_FAILURE:
      return { ...state, error: action.payload };

    case ValetDataActionTypes.GET_VALET_FLIGHT_TIMES_SUCCESS:
      return { ...state, flightTimes: action.payload };

    case ValetDataActionTypes.GET_VALET_CUSTOMER_DATA_SUCCESS:
      return { ...state, flightCustomerData: action.payload, error: null };

    case ValetDataActionTypes.FILTER_VALET_FLIGHTS_SUCCESS:
      return { ...state, filteredFlightIds: action.payload };



    case ValetDataActionTypes.SET_VALET_DOF:
      return {
        ...state,
        dof: action.payload,
        flightIds: [],
        flightCustomerData: null,
      };

    case ValetDataActionTypes.SET_VALET_CUSTOMER_DATA_LOADING:
      return { ...state, customerDataLoading: action.payload };

    case ValetDataActionTypes.SET_VALET_FLIGHT_ID_LOADING:
      return { ...state, flightIdsLoading: action.payload };

    case ValetDataActionTypes.SET_VALET_SELECTED_FLIGHT_IDS:
      return { ...state, selectedFlightIds: action.payload };

    case ValetDataActionTypes.SET_VALET_CUSTOMER_COUNT:
      return { ...state, customerCount: action.payload };

    case ValetDataActionTypes.SET_VALET_FILTERED_FLIGHT_IDS:
      return { ...state, filteredFlightIds: action.payload };

    case ValetDataActionTypes.SET_VALET_FILTER_TIME_START:
      state.filter.time.start = action.payload;
      return { ...state };

    case ValetDataActionTypes.SET_VALET_FILTER_TIME_END:
      state.filter.time.end = action.payload;
      return { ...state };

    case ValetDataActionTypes.SET_VALET_ABSENT_CUSTOMERS:
      return { ...state, absentCustomers: action.payload };

    case ValetDataActionTypes.SET_VALET_DESTINATION:
      return { ...state, destination: action.payload };


    default:
      return state;
  }
};

export default valetDataReducer;
